import { Point } from '../Misc/Utils';

export class InputHandler implements InputRegisterer{
    private document: Document
    private clicking = false
    private lastMousePoint : Point = [0,0]
    private listeners : InputListener[] = []
    private keyListeners: KeyInputListener[] = []

    constructor(document: Document){
        this.document = document;
    }

    public registerForEvents(outlineCanvas: HTMLCanvasElement, canvas: HTMLCanvasElement){
        if(outlineCanvas.getContext('2d')){
            outlineCanvas.addEventListener("dragover", this.onDragOver);
            //canvas.addEventListener("drop", this.onDrop);
            outlineCanvas.addEventListener("mousedown", this.onMouseDown);
            outlineCanvas.addEventListener("mousemove", this.onMouseMove);
            outlineCanvas.addEventListener("dblclick", this.onDoubleClick);
        }else{
            canvas.addEventListener("dragover", this.onDragOver);
            //canvas.addEventListener("drop", this.onDrop);
            canvas.addEventListener("mousedown", this.onMouseDown);
            canvas.addEventListener("mousemove", this.onMouseMove);
            canvas.addEventListener("dblclick", this.onDoubleClick);
        }
        if(this.document){
            this.document.addEventListener("mouseup", this.onMouseUp);
            this.document.addEventListener("keydown", this.onKeyDown);
            this.document.addEventListener("keyup", this.onKeyUp);
        }
    }

    public addListener(newListener: InputListener){
        if(newListener){
            this.listeners.push(newListener);
        }
    }

    public removeListener(oldListener: InputListener){
        if(oldListener){
            for(var index = 0; index  < this.listeners.length; index++){
                if(this.listeners[index] == oldListener){
                    this.listeners.splice(index, 1)
                }
            }
        }
    }

    public addKeyListener(newListener: KeyInputListener){
        if(newListener){
            this.keyListeners.push(newListener);
        }
    }

    public removeKeyListener(oldListener: KeyInputListener){
        if(oldListener){
            for(var index = 0; index  < this.keyListeners.length; index++){
                if(this.keyListeners[index] == oldListener){
                    this.keyListeners.splice(index, 1)
                }
            }
        }
    }

    onKeyDown = (event:any) =>{
        for(let listener of this.keyListeners){
            listener.onKeyDown(event.key);
        }
    }

    onKeyUp = (event:any) =>{
        for(let listener of this.keyListeners){
            listener.onKeyUp(event.key);
        }
    }

    onMouseDown = (event:any) => {
        this.clicking = true;
        this.lastMousePoint = this.getXYonCanvas(event);
        console.log("mousedown "+this.lastMousePoint[0]+" "+this.lastMousePoint[1]);
        for(let listener of this.listeners){
            listener.onMouseDown(this.lastMousePoint);
        }
    }

    onMouseUp = () => {
        this.clicking = false;
        console.log("on mouse up");
        for(let listener of this.listeners){
            listener.onMouseUp(this.lastMousePoint);
        }
    }

    onMouseMove = (event:any) => {
        let curPoint = this.getXYonCanvas(event);
        for(let listener of this.listeners){
            listener.onMouseMove(this.lastMousePoint, curPoint);
        }
        this.lastMousePoint = curPoint;
    }

    onDoubleClick = (event:any) => {
        let curPoint = this.getXYonCanvas(event);
        console.log("DOUBLE CLICK "+this.lastMousePoint[0]+" "+this.lastMousePoint[1]);
        for(let listener of this.listeners){
            listener.onDoubleClick(this.lastMousePoint);
        }
    }

    /*onDrop = (event:any) => {
        let src : string  = (event as any).dataTransfer.getData("uri");
        console.log("dropping " +src );
        let image = new BImage(this.getXYonCanvas(event), src, this.scene.getFrameRange());
        this.scene.addBObject(image);
    }*/

    onDragOver = (event:any) => {
        event.preventDefault();
    }

    getXYonCanvas(event:any) : [number , number] {
        let rect = this.getCanvas().getBoundingClientRect();
        return [ event.pageX - rect.left, event.pageY - rect.top];
    }

    getCanvas = () => {
        return <HTMLCanvasElement> this.document.getElementById('canvas');
    }

    getOutlineCanvas = () => {
        return <HTMLCanvasElement> this.document.getElementById('outlineCanvas');
    }
}

export interface InputRegisterer{
    addListener(newListener: InputListener): void;
    removeListener(oldListener: InputListener): void;
    addKeyListener(newListener: KeyInputListener): void;
    removeKeyListener(oldListener: KeyInputListener): void;
}

export interface InputListener{
    onMouseDown(point:Point):void;
    onMouseUp(point:Point):void;
    onMouseMove(from: Point, to: Point):void;
    onDoubleClick(point:Point):void;
}

export interface KeyInputListener{
    onKeyDown(key:string):void;
    onKeyUp(key:string):void;
}